var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"item\">\n        <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.Document",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":6,"column":42},"end":{"line":6,"column":68}}}))
    + ":</span>\n        <span class=\"leaflet-popup-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"document") : depth0), depth0))
    + "</span>\n      </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"item\">\n        <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Common.DocumentRoot",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":13,"column":42},"end":{"line":13,"column":72}}}))
    + ":</span>\n        <span class=\"leaflet-popup-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"documentRoot") : depth0), depth0))
    + "</span>\n      </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"Value") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":6},"end":{"line":24,"column":13}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"item\">\n          <span class=\"leaflet-popup-label\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"Translate") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":21,"column":44},"end":{"line":21,"column":62}}}))
    + ":</span>\n          <span class=\"leaflet-popup-text\">"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"Value") : depth0), depth0))
    + "</span>\n        </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n  <div class=\"leaflet-popup-header\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "</div>\n  <div class=\"leaflet-popup-fuel-station\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"document") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":9,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"documentRoot") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":16,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"ParameterTemplates") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":4},"end":{"line":25,"column":13}}})) != null ? stack1 : "")
    + "  </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-workshop-part-popup.hbs
// module id = q9zf
// module chunks = 1